// Enum for account tag set to value of url slug for each tab
export enum AccountTabs {
  OrderHistory = 'orders',
  PaymentMethods = 'payment-methods',
  GiftCards = 'gift-cards',
  Addresses = 'addresses',
  AccountSetting = 'account-settings',
  ChangePassword = 'change-password',
  EmailPreferences = 'email-preferences',
  MemberRewards = 'member-rewards',
}
